import React, {useEffect} from 'react';
import withParamsPageLoader from '../../../../../hoc/withParamsPageLoader';
import { loadCaseData } from '../CaseInfo/action';
import { Access } from '../CaseInfo/MainContent/Access';
import { Description } from '../CaseInfo/MainContent/Description';
import { History } from '../CaseInfo/MainContent/History';
import { MainInfo } from '../CaseInfo/MainContent/MainInfo';
import { Media } from '../CaseInfo/MainContent/Media';
import { Messages } from '../CaseInfo/MainContent/Messages';
import { StyledExportCase } from './Style';

import { jsPDF } from "jspdf";

const data = `
<html>
<body>
<style>

html, body {
    width: 100%;
    margin: 0px;
    padding: 0px;
}

* {
    box-sizing: border-box;
}

.section {
    padding: 4rem 0;
}

.container {
    display: block;
    font-family: "Open Sans", Arial, Helvetica, sans-serif;
    font-size: 16px;
    line-height: 24px;
    background: #fbfbfb;
    padding: 20px;
}

.caseMainInfo {
    padding-left: 40px;
    padding-right: 40px;
}

.caseInfoRow {
    display: grid;
    column-gap: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
    row-gap: 20px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
}

.text-box label {
    color: #8a8a8a;
    font-weight: 500;
}

.text-box p {
    margin: 10px;
}

.caseDescriptionContainer p {
  width: 100%;
}

.caseEvidenceContainer {
    padding-left: 40px;
    padding-right: 40px;
}

.photosGrid {
    display: grid;
    column-gap: 12px;
    grid-template-columns: 1fr 1fr 1fr;
    row-gap: 12px;
}

.filesGrid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 12px;
    row-gap: 12px;
}


.caseFileInfo {
    color: #858585;
}

.item-name {
    color: #333333;
}

.caseAccessContainer {
    padding-left: 40px;
    padding-right: 40px;
}

.accessTable{
    display: table;
    border-collapse: separate;
    border-color: grey;
    width: 100%;
}

.accessTable tr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: center;
    border-color: grey;
    line-height: 19.5px;
    margin-bottom: 4px;
    margin-top: 4px;
    padding-left: 15px;
    padding-right: 15px;
    vertical-align: middle;
}

.caseMessagesContainer {
    padding-left: 40px;
    padding-right: 40px;
    margin-bottom: 40px;
}

.chat-header h3 {
    font-weight: bold;
    margin-left: 2rem;
}

.chat-main-box {
    padding-left: 40px;
    padding-right: 40px;
}

.chat-message{
    background: #f1f1f1;
    border-radius: 18px;
    font-size: 14px;
    line-height: 21px;
    margin-block-end: 14px;
    margin-block-start: 14px;
    padding-bottom: 10px;
    padding-left: 20px;
    padding-right: 40px;
    padding-top: 10px;
    width: fit-content;
    position: relative;
}

.our-message {
    background: #418eeb;
    color: white;
    margin-left: auto;
}

.chat-main-box .timestamp{
    color: #a5a5a5;
    font-size: 11.5px;
    line-height: 17.25px;
    position: absolute;
    top: 53.3px;
    width: 100%;
}

.caseHistoryContainer{
    padding-left: 40px;
    padding-right: 40px;
}

.latestActivity {
    font-size: 12.8px;
    line-height: 19.2px;
    margin-bottom: 20px;
    margin-top: 20px;
    min-width: fit-content;
    width: 100%;
}

.li-wrapper {
    position: relative;
    border-left: solid 2px #dddddd;
    padding-left: 16px;
    padding-bottom: 30px;
}

.circle {
    position: absolute;
    left: -6.5px;
    display: inline-block;
    width: 12px;
    height: 12px;
    background: white;
    border: solid 2px #418eeb;
    border-radius: 50%;
}

.li-wrapper:first-of-type .circle {
    background: #418eeb;
}

.caseHistoryContainer p {
    margin: 0;
    transform: translateY(-4px);
}

.caseHistoryContainer .li-wrapper:first-of-type p.main-item {
    font-weight: bold;
}

.caseHistoryContainer p.timestamp {
    color: #a5a5a5;
}
    
</style>

<div class="container">
    <div class="section">
  <h2>Case main info</h2>
  <div class="caseMainInfo">
      <div class="caseInfoRow">
          <div class="text-box">
              <label>Case Subject</label>
              <p>Money laundering at B</p>
          </div>
          <div class="text-box">
              <label>Company</label>
              <p>Millenium Corporation</p>
          </div>
          <div class="text-box">
              <label>Created Date</label>
              <p>22 Jul 2022, 10:58 AM</p>
          </div>
          <div class="text-box">
              <label>Created By</label>
              <p>Emilia Johanson</p>
          </div>
      </div>
      <div class="caseInfoRow">
          <div class="text-box">
              <label>Status</label>
              <p class="status-buttons blue-status false false">New</p>
          </div>
          <div class="text-box">
              <label>Source</label>
              <p>Email</p></div>
              <div class="text-box">
                  <label>Confidentiality</label>
                  <p>Confidential</p>
              </div>
              <div class="text-box">
                  <label>Category</label>
                  <p>Fraud</p>
              </div>
          </div>
          <div class="sc-dmRaPn eKhbEK">
              <div class="text-box">
                  <label>Parties Involved</label>
                  <p>Upper Management</p>
              </div>
          </div>
          </div>
          <hr>
      </div>
      
      <div class="section">
        <h2>Case description</h2>
        <div class="caseDescriptionContainer" style="padding-top: 2rem;">
            <div style="margin-top: 0px;">
                <div class="sc-bczRLJ hfpyDg">
                    <div>
                        <p class="description-dates" style="margin-top: 0px;">Created date : 7/22/2022</p>
                        <p class="description-dates">Last updated date : 8/25/2022</p>
                    </div>
                </div>
            </div>
            <p>lorem test 10...Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque leo bibendum dui morbi. Tristique purus, adipiscing id risus nulla. Et enim pretium sed aliquam. Amet, cras morbi ut in non neque. Ipsum netus massa nunc mauris arcu. Massa nibh sed lobortis elit mauris nulla mattis amet, mi. Nunc massa proin lorem sit semper ut.</p><p></p><p> Risus lectus arcu, adipiscing tortor pretium sociis tellus eget. Orci, purus gravida nibh consectetur. Ut donec sed maecenas suscipit sed magna. Eget a pharetra, imperdiet at eget ac. Lorem consequat suscipit nascetur diam eget sit ultricies. Diam eu nunc, vel neque, odio. Pharetra, tempus, urna ultricies velit mauris et egestas est.</p><p></p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque leo bibendum dui morbi. Tristique purus, adipiscing id risus nulla. Et enim pretium sed aliquam. Amet, cras morbi ut in non neque. Ipsum netus massa nunc mauris arcu. Massa nibh sed lobortis elit mauris nulla mattis amet, mi. Nunc massa proin lorem sit semper ut.</p><p></p><p>Risus lectus arcu, adipiscing tortor pretium sociis tellus eget. Orci, purus gravida nibh consectetur. Ut donec sed maecenas suscipit sed magna. Eget a pharetra, imperdiet at eget ac. Lorem consequat suscipit nascetur diam eget sit ultricies. Diam eu nunc, vel neque, odio. Pharetra, tempus, urna ultricies velit mauris et egestas est. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque leo bibendum dui morbi.</p><p></p><p>Tristique purus, adipiscing id risus nulla. Et enim pretium sed aliquam. Amet, cras morbi ut in non neque. Ipsum netus massa nunc mauris arcu. Massa nibh sed lobortis elit mauris nulla mattis amet, mi. Nunc massa proin lorem sit semper ut. Risus lectus arcu, adipiscing tortor pretium sociis tellus eget. Orci, purus gravida nibh consectetur. Ut donec sed maecenas suscipit sed magna. Eget a pharetra, imperdiet at eget ac. Lorem consequat suscipit nascetur diam eget sit ultricies. Diam eu nunc, vel neque, odio. Pharetra, tempus, urna ultricies velit mauris et egestas est.</p>
        </div>
      </div>
      </div>
      <hr>
      <div class="section">
      <h2>Case evidence</h2>
      <div class="caseEvidenceContainer">
          <div class="sc-eFWqGp dZgdEJ">
              <div>
                  <h3>Photos</h3>
                  <div class="photosGrid">
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">mountains.jpg</span>
                              <div class="caseFileInfo">
                                  <span class="item-date">07/27/2022</span>
                                  <span class="item-size">&nbsp;3.7mb</span>
                              </div>
                          </div>
                      </div>
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">forest.jpg</span>
                              <div class="caseFileInfo">
                                  <span class="item-date">07/27/2022</span>
                                  <span class="item-size">&nbsp;3.3mb</span>
                              </div>
                          </div>
                      </div>
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">river.jpg</span>
                              <div class="caseFileInfo"><span class="item-date">07/27/2022</span>
                                  <span class="item-size">&nbsp;3.2mb</span>
                              </div>
                          </div>
                      </div>
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">happy emoji.png</span>
                              <div class="caseFileInfo">
                                  <span class="item-date">07/29/2022</span>
                                  <span class="item-size">&nbsp;1kb</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div>
                  <h3>Files</h3>
                  <div class="filesGrid">
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">some text file.txt</span>
                              <div class="caseFileInfo">
                                  <span class="item-date">07/27/2022</span>
                                  <span class="item-size">&nbsp;1kb</span>
                              </div>
                          </div>
                      </div>
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">generatedBy_react-csv (20).csv</span>
                              <div class="caseFileInfo">
                                  <span class="item-date">07/30/2022</span>
                                  <span class="item-size">&nbsp;1kb</span>
                              </div>
                          </div>
                      </div>
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">test-file.txt</span>
                              <div class="caseFileInfo">
                                  <span class="item-date">09/09/2022</span>
                                  <span class="item-size">&nbsp;1kb</span>
                              </div>
                          </div>
                      </div>
                      <div class="sc-bWXABl frZRxL">
                          <div class="caseFile">
                              <span class="item-name">test-file.txt</span>
                              <div class="caseFileInfo">
                                  <span class="item-date">09/09/2022</span>
                                  <span class="item-size">&nbsp;1kb</span>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      </div>
      <hr>
      <div class="section">
      <h2>Case access</h2>
      <div class="caseAccessContainer">
          <div class="sc-dFdIVH hySRSL">
              <table class="accessTable">
                  <thead>
                      <tr>
                          <th>Handler</th>
                          <th>Status</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr>
                          <td>Emilia Johanson</td>
                          <td class="status-buttons red-status">INACTIVE</td>
                      </tr>
                      <tr>
                          <td>Rendy Greenlee</td>
                          <td class="status-buttons green-status">ACTIVE</td>
                      </tr>
                  </tbody>
              </table>
          </div>
      </div>
      </div>
      <hr>
      <div class="section">
      <h2>Case messages</h2>
      <div class="caseMessagesContainer">
          <div class="sc-brCFrO dIwfwS">
              <div class="chat-header">
                  <h3>Rendy Greenlee</h3>
              </div>
              <div class="chat-main-box">
                  <p class="chat-message our-message">:)<span class="timestamp">06:06 PM</span></p>
                  <p class="chat-message not-our-message">this is some text</p>
                  <p class="chat-message not-our-message">this test is a lot longuer to see how it looks when the message spans several lines in the the chat box.<span class="timestamp">12:07 PM</span></p>
                  <p class="chat-message our-message">some response here...</p>
                  <p class="chat-message our-message">and another message<span class="timestamp">02:00 AM</span></p>
                  <p class="chat-message not-our-message">this is an api test</p>
                  <p class="chat-message not-our-message">from chatbox<span class="timestamp">06:40 PM</span></p>
                  <p class="chat-message our-message">Writing from Samuel</p>
                  <p class="chat-message our-message">Hi Emilia.</p>
                  <p class="chat-message our-message"><span class="timestamp">09:05 AM</span></p>
                  <p class="chat-message not-our-message">test 2</p>
                  <p class="chat-message not-our-message">test 3</p>
                  <p class="chat-message not-our-message">test 4</p>
                  <p class="chat-message not-our-message">test 5<span class="timestamp">12:38 PM</span></p>
              </div>
          </div>
      </div>
      </div>
      <hr>
      <div class="section">
      <h2>Case history</h2>
      <div class="caseHistoryContainer">
          <div class="latestActivity">
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Case details (deadline/priority/handler) were changed.</p>
                  <p class="timestamp">12 September 2022, 17:31</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Report case description was changed.</p>
                  <p class="timestamp">12 September 2022, 17:29</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Case details (deadline/priority/handler) were changed.</p>
                  <p class="timestamp">12 September 2022, 17:26</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Case details (deadline/priority/handler) were changed.</p>
                  <p class="timestamp">12 September 2022, 17:22</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Case details (deadline/priority/handler) were changed.</p>
                  <p class="timestamp">12 September 2022, 17:15</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Case details (deadline/priority/handler) were changed.</p>
                  <p class="timestamp">12 September 2022, 17:13</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Case details (deadline/priority/handler) were changed.</p>
                  <p class="timestamp">12 September 2022, 17:08</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">test-file.txt file was added to media collection.</p>
                  <p class="timestamp">9 September 2022, 20:50</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">[object Object] file was added to media collection.</p>
                  <p class="timestamp">9 September 2022, 20:48</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Report case description was changed.</p>
                  <p class="timestamp">9 September 2022, 20:29</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Report case description was changed.</p>
                  <p class="timestamp">9 September 2022, 20:29</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Report case description was changed.</p>
                  <p class="timestamp">9 September 2022, 20:29</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Report case description was changed.</p>
                  <p class="timestamp">9 September 2022, 20:29</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Report case description was changed.</p>
                  <p class="timestamp">9 September 2022, 20:09</p>
              </div>
              <div class="li-wrapper">
                  <div class="circle"></div>
                  <p class="main-item">Case details (deadline/priority/handler) were changed.</p>
                  <p class="timestamp">9 September 2022, 20:09</p>
              </div>
          </div>
      </div>
      </div>
  </div>
</body>
</html>
`

export const ExportCase = withParamsPageLoader(loadCaseData, ({ caseId, loadedPageData }) => {

  useEffect(() => {
    const pdf = new jsPDF({
      orientation: "p", 
      unit:"px", 
      format:"letter", 
      hotfixes: ["px_scaling"],
    });
    pdf.html(data,{
      width: 810,
      windowWidth: 810
    }).then(() => {
      pdf.save("case export.pdf");
    })
  }, [])

  return <StyledExportCase>
    <h2>Case main info</h2>
          <MainInfo caseData={loadedPageData} />
          <h2>Case description</h2>
           <Description caseData={loadedPageData} />
           <h2>Case evidence</h2>
          <Media caseData={loadedPageData} />
          <h2>Case access</h2>
          <Access />
          <h2>Case messages</h2>
          <Messages caseData={loadedPageData} />
          <h2>Case history</h2>
          <History />
  </StyledExportCase>
}
)